import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { fadeInUp400ms } from 'src/@vex/animations/fade-in-up.animation';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { UserAuthDto } from 'src/app/shared/models/auth/user-auth-dto.model';
import { UserAuth } from 'src/app/shared/models/auth/user-auth.model';

@Component({
  selector: 'vex-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    fadeInUp400ms
  ]
})
export class LoginComponent implements OnInit {

  form: FormGroup;
  dto: UserAuthDto = new UserAuthDto();

  inputType = 'password';
  visible = false;
  userAuth: UserAuth;

  constructor(private router: Router,
    private formBuilder: FormBuilder,
    private cd: ChangeDetectorRef,
    private toastrService: ToastrService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    if (this.authService.isAuthenticated()) {
      this.toastrService.success("Ya estas autenticado");
      this.router.navigate(['/dashboard']);
    }

    this.form = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  display() {
    //window.open('/assets/display.html', '_blank');
    window.open('http://apps.icg.com.bo/display.html', '_blank');
  }

  send() {
    this.dto.username = this.form.value.username;
    this.dto.password = this.form.value.password;
    this.authService.login(this.dto)
      .subscribe(
        response => {
          if (response.status) {
            if (response.data.user.id_usuario === undefined) {
              this.toastrService.error('Usuario sin Acceso a Sistema DSC');
            } else {
              this.toastrService.success("Login correcto");
              this.userAuth = response.data.user;
              this.authService.saveUser(this.userAuth);
              this.authService.saveToken(response.data.token);
              this.router.navigate(['/dashboard']);
            }
          } else {
            this.toastrService.warning(response.message);
          }
        },
        err => {
          this.toastrService.error('usuario o contraseña incorrectos');
        }
      );

  }

  toggleVisibility() {
    if (this.visible) {
      this.inputType = 'password';
      this.visible = false;
      this.cd.markForCheck();
    } else {
      this.inputType = 'text';
      this.visible = true;
      this.cd.markForCheck();
    }
  }
}
